import { Modal } from "antd";
import styled from "styled-components";

export const StyledAppModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    padding: 16px;
    background: ${({ theme }) => theme.palette.background.default};
  }
  svg {
    cursor: pointer;
  }
`;
